import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { useLocation, useNavigate } from "react-router-dom";

import Cookies from "js-cookie";

import Nav from "react-bootstrap/Nav";

import {
  createRole,
  editRole,
  updatePasswordRole,
} from "../../../../redux/accountManagementReducer/actionsAccountManagement";
import {
  getAllGimsUserPositions,
  getDictionaryGimsSections,
  getGimsDepartmentAll,
} from "../../../../redux/actions";

import GeneralInformation from "../generalInformation/generalInformation";
import Roles from "../roles/roles";
import NotificationWindow from "../../../../components/GeneralComponents/NotificationWindow/NotificationWindow";

import styles from "./workingPage.module.css";

const WorkingPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const type = location.state?.type;

  const userId = Cookies.get("userId");

  const [selectedKey, setSelectedKey] = useState("generalInformation");
  const [isGeneralInformation, setIsGeneralInformation] = useState(false);
  const [isClickRoles, setIsClickRoles] = useState(false);
  const [showNotificationWindow, setShowNotificationWindow] = useState(false);
  const [dataFromGeneralInformation, setDataFromGeneralInformation] = useState(
    {},
  );
  const [goBack, setGoBack] = useState(false);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [generalInformationErrors, setGeneralInformationErrors] =
    useState(false);

  const accountManagementErrors = useSelector((state) => {
    const { accountManagementReducer } = state;
    return accountManagementReducer;
  });

  const accountManagement = useSelector((state) => {
    const { accountManagementReducer } = state;
    return accountManagementReducer.accountManagement;
  });

  const handleSelect = (selected) => {
    if (selected === "roles" && !isGeneralInformation) {
      return false;
    } else {
      setSelectedKey(selected);
    }
  };
  const checkGeneralInformation = () => {
    setIsClickRoles(true);
  };

  const getDataFromGeneralInformation = (data, data2) => {
    if (!data) return;

    setGeneralInformationErrors(Object.keys(data2).length > 0);

    setDataFromGeneralInformation({ ...data });
    setIsGeneralInformation(false);

    const commonConditions =
      data.login &&
      data.fio &&
      data.phone &&
      data.userPosition &&
      data.department;

    if (
      (type === "create" &&
        commonConditions &&
        data.password &&
        data.validUntil) ||
      (type === "edit" && commonConditions) ||
      (type === "update" && data.password && data.validUntil)
    ) {
      setIsGeneralInformation(true);
    }
  };

  const clickOnSaveData = async (data, event) => {
    event.preventDefault();
    let roleIds = "";

    if (type === "create" || type === "edit") {
      roleIds = selectedRoles
        .filter((item) => item.isRole === true)
        .map((item) => item.id)
        .join(",");
    }

    if (type === "create") {
      const objectForCreate = {
        password: dataFromGeneralInformation.password,
        login: dataFromGeneralInformation.login,
        name: dataFromGeneralInformation.fio,
        phone: dataFromGeneralInformation.phone,
        userPosition: Number(dataFromGeneralInformation.userPosition),
        department: dataFromGeneralInformation.department,
        section: dataFromGeneralInformation.section,
        validUntil: dataFromGeneralInformation.validUntil,
        note: dataFromGeneralInformation.note,
        registerLogin: dataFromGeneralInformation.registerLogin,
        registerPassword: dataFromGeneralInformation.registerPassword,
        roles: roleIds,
      };
      dispatch(createRole(objectForCreate));
    }

    if (type === "edit") {
      const objectForCreate = {
        login:
          dataFromGeneralInformation.login === accountManagement.login
            ? null
            : dataFromGeneralInformation.login,
        name:
          dataFromGeneralInformation.fio === accountManagement.fio
            ? null
            : dataFromGeneralInformation.fio,
        phone:
          dataFromGeneralInformation.phone === accountManagement.phone
            ? null
            : dataFromGeneralInformation.phone,
        userPosition:
          Number(dataFromGeneralInformation.userPosition) ===
          Number(accountManagement.userPosition)
            ? null
            : Number(dataFromGeneralInformation.userPosition),
        department:
          dataFromGeneralInformation.department === accountManagement.department
            ? null
            : dataFromGeneralInformation.department,
        section:
          dataFromGeneralInformation.section === accountManagement.section
            ? null
            : dataFromGeneralInformation.section,
        roles: roleIds,
        registerLogin:
          dataFromGeneralInformation.registerLogin ===
          accountManagement.registerLogin
            ? null
            : dataFromGeneralInformation.registerLogin,
        registerPassword:
          dataFromGeneralInformation.registerPassword ===
          accountManagement.registerPassword
            ? null
            : dataFromGeneralInformation.registerPassword,
        loginedUser: Number(userId),
      };
      dispatch(editRole(accountManagement.id, objectForCreate));
    }

    if (type === "update") {
      const objectForCreate = {
        password: data.password,
        validUntil: data.validUntil,
      };
      dispatch(updatePasswordRole(accountManagement.id, objectForCreate));
    }

    setShowNotificationWindow(true);
  };

  const handleCloseClick = () => {
    navigate("/accountManagement");
  };

  const setHeaderName = (typeHeader) => {
    const headerName = {
      create: "Добавить пользователя",
      update: "Продлить срок действия пароля",
      edit: "Редактировать пользователя",
    };
    return headerName[typeHeader];
  };

  const setNotificationWindowText = (typeNotification) => {
    const notificationWindowText = {
      create:
        accountManagementErrors.textError || "Пользователь успешно добавлен",
      update:
        accountManagementErrors.textError || "Установлен новый срок действия!",
      edit: accountManagementErrors.textError || "Изменения сохранены",
    };
    return notificationWindowText[typeNotification];
  };

  const setInitialData = () => {
    if (type === "create") {
      return dataFromGeneralInformation;
    }

    if (Object.keys(dataFromGeneralInformation).length > 0) {
      return {
        ...dataFromGeneralInformation,
        gimsRoles: accountManagement.gimsRoles,
      };
    } else {
      return accountManagement;
    }
  };

  const setInitialRolesData = () => {
    if (type === "create") {
      return selectedRoles;
    }

    if (selectedRoles.length > 0) {
      return selectedRoles;
    } else {
      return accountManagement.gimsRoles;
    }
  };

  const getDataFromRoles = (data) => {
    setSelectedRoles(data);
  };

  useEffect(() => {
    if (showNotificationWindow === true) {
      setGoBack(true);
    }
    if (
      goBack === true &&
      showNotificationWindow === false &&
      accountManagementErrors.textError === ""
    ) {
      handleCloseClick();
    }
  }, [showNotificationWindow]);

  useEffect(() => {
    if (Object.keys(accountManagement).length === 0 && type !== "create") {
      handleCloseClick();
    }
  }, [accountManagement]);

  useEffect(() => {
    dispatch(getAllGimsUserPositions());
    dispatch(getGimsDepartmentAll());
    dispatch(getDictionaryGimsSections());
  }, []);

  return (
    <div className={styles["component-container"]}>
      <h2 className={styles["component-caption"]}>{setHeaderName(type)}</h2>
      <div className={styles["content-block"]}>
        <Nav
          variant="tabs"
          activeKey={selectedKey}
          onSelect={handleSelect}
          className={styles["nav"]}
          defaultActiveKey="generalInformation"
        >
          <Nav.Item>
            <Nav.Link
              className={`${styles["left-link"]} ${
                selectedKey === "generalInformation"
                  ? styles["custom-active-link"]
                  : ""
              }`}
              eventKey="generalInformation"
            >
              Общая информация
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              disabled={type === "update" || generalInformationErrors}
              className={`${styles["right-link"]} ${
                selectedKey === "roles" ? styles["custom-active-link"] : ""
              }`}
              onClick={checkGeneralInformation}
              eventKey="roles"
            >
              Роли
            </Nav.Link>
          </Nav.Item>
        </Nav>
        <div className={styles["nav-content"]}>
          {selectedKey === "generalInformation" ? (
            <GeneralInformation
              getData={getDataFromGeneralInformation}
              isClickRoles={isClickRoles}
              handleCloseClick={handleCloseClick}
              type={type}
              onSave={clickOnSaveData}
              initialData={setInitialData()}
            />
          ) : (
            <Roles
              getData={getDataFromRoles}
              type={type}
              initialData={setInitialRolesData()}
              onSave={clickOnSaveData}
              handleCloseClick={handleCloseClick}
            />
          )}
        </div>
      </div>
      <NotificationWindow
        isError={showNotificationWindow}
        show={showNotificationWindow}
        setShow={setShowNotificationWindow}
        messageText={setNotificationWindowText(type)}
      />
    </div>
  );
};

export default WorkingPage;
